import { render, staticRenderFns } from "./TournamentSettingsView.vue?vue&type=template&id=5002ad26"
import script from "./TournamentSettingsView.vue?vue&type=script&lang=js"
export * from "./TournamentSettingsView.vue?vue&type=script&lang=js"
import style0 from "./TournamentSettingsView.vue?vue&type=style&index=0&id=5002ad26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports